import { FC, useContext, memo, useState, useRef } from "react";
import { Link } from "react-router-dom";

import { AuthContext } from "src/context/authContext";

import { TreatableProps } from "src/pages/actionDashboard/types";
import { getDateFormat } from "src/helpers/dateTime";
import AddNote from "src/components/modals/addNote";
import { useOnClickOutside } from "src/hooks/useClickOutside";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import WidgetWithTooltip from "../WidgetTooltip";


type ModalState<T = any> = {
    isModalVisible: boolean;
} & T;

const CoverageAvailableTableRow: FC<{
    treatable: TreatableProps;
    refreshListing: () => void;
    key: number
}> = ({ treatable, refreshListing, key }): JSX.Element => {

    const { isManufacturer, userData } = useContext(AuthContext);
    const [saveNoteModal, setSaveNoteModal] = useState<ModalState<{ caseId: number }>>({
        isModalVisible: false,
        caseId: 0
    });
    const AddNoteDisbaled = () => {
        if (userData?.ref_type === "fam_am" || userData?.ref_type === "fam_rm") {
            return false;
        } else {
            return true;
        }
    }
    const toggleIconRef = useRef<HTMLElement | null>(null);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, changeInfoIconIndex] = useState<number>(-1);

    useOnClickOutside(toggleIconRef, () => {
        changeInfoIconIndex(-1);
    });

    return (
        <>
            <tr>
                {/* {treatable.patient_name !== 'Redacted' ?
        <td className="text-center align-middle">
          <Link 
            to={`/global_patients/${treatable.patient_id}`}
            
          >
            {treatable.patient_name}
          </Link>
        </td>
        :
        <td className="text-center align-middle">{treatable.patient_name}</td>
      } */}
                <td className="text-center align-middle">
                    {treatable.patient_name !== "Redacted" && treatable.patient_initials_dob ? (
                        <Link to={`/global_patients/${treatable.patient_id}/${treatable.bi_case_id}`}>
                            {treatable.patient_initials_dob}
                        </Link>
                    ) : (
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>SF submitted is outdated</Tooltip>}
                        >
                            <i className="fas fa-info-circle text-color-yellow" style={{ color: "#f2ba45" }}></i>
                        </OverlayTrigger>
                    ) }
                </td>
                <td className="text-center align-middle">
                    <Link
                        to={`/cases/detail/${treatable.bi_case_id}`}
                        className={`${treatable.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}
                    >
                        {treatable.original_id}
                    </Link>
                </td>
                <td className="text-center align-middle">
                    {treatable.received_at ? getDateFormat(treatable.received_at) : ""}

      </td>
                <td className="text-center align-middle">
                    {treatable.product_name}
                </td>
                <td className="text-center align-middle">
                    {treatable.review_type}
                </td>
                <td className="text-center align-middle">
                    {treatable.qty}
                </td>
                <td className="text-center align-middle">
                    {treatable.refills}
                </td>
                {/* <td className="text-center align-middle">
                    {treatable.auto_transfer ? (
                        <i className="fa fa-check text-success"></i>
                    ) : (
                        <i className="fa fa-times text-danger"></i>
                    )}
                </td> */}
                {/* <td className="text-center align-middle">
                    {treatable.drug_name === "iovera°" ? treatable.drug_name : treatable.drug_name === "zilretta" ? treatable.drug_name.toUpperCase() : treatable.drug_name}


                </td> */}
                <td className="text-center align-middle">
                    {isManufacturer ? getDateFormat(treatable.bi_completed) : treatable.bi_completed}
                </td>
                 <td className="text-center align-middle">
                    {treatable.pa_required}
                </td>
                <td className="text-center align-middle">
                    {treatable.payer}
                </td>
                <td className="text-center align-middle">
                    {treatable.insurance_type}
                </td>
                <td className="text-center align-middle">{treatable.released}</td>
                
                {/* <td className="text-center align-middle">
                    {treatable.region}
                </td>
                <td className="text-center align-middle">
                    {treatable.territory}
                </td>
                <td className="text-center align-middle">
                    {treatable.state}
                </td> */}
                {/* <td className="text-center align-middle">
                    <span
                        className={`badge ${treatable.medical_coverage_status_color !== 5 ? "" : ""} background-color-${treatable.medical_coverage_status_color}`}>
                        {treatable.medical_coverage_status}
                    </span>
                </td> */}
                <td className="text-center align-middle">
                    <span
                        className={`badge ${treatable.pharmacy_coverage_status_color}`}>
                        {treatable.pharmacy_coverage_status}
                    </span>
                </td>
                <td className="text-center align-middle">
                    <WidgetWithTooltip caseId={treatable.bi_case_id} physician={treatable.physician ?? ""} practice={treatable.practice ?? {}} />
                </td>
                {/* <td className="text-center fw-bold align-middle">
        {treatable.next_steps ? treatable.next_steps.next_step_verbiage || "" : ""}
      </td> */}
                {/* <td className="align-middle">
          {treatable.copay_status}
      </td> */}
                {/* <td className={`text-center align-middle`}>
        <ManufacturerNextStepActions refreshListing={refreshListing} kase={treatable} next_steps={treatable.next_steps} />
      </td> */}
                {/* <td className="text-center align-middle" style={{ minWidth: 70 }}>
                    <button
                        className="btn btn-success btn-sm m-1 text-nowrap"
                        onClick={() =>
                            setSaveNoteModal({ isModalVisible: true, caseId: treatable.bi_case_id })
                        }
                        disabled={AddNoteDisbaled()}
                    >
                        {'Add Note'}
                    </button>
                </td> */}
            </tr>
            {saveNoteModal.isModalVisible && (
                <AddNote
                    {...saveNoteModal}
                    hideModal={() => setSaveNoteModal({ isModalVisible: false, caseId: 0 })}
                    refreshListing={refreshListing}
                />
            )}
        </>
    )
}

export default memo(CoverageAvailableTableRow);
